import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './Guards/auth.guard';
import { NgModel } from '@angular/forms';
import { NgModule } from '@angular/core';

export const routes: Routes = [
    //Default Route
    { path: '', redirectTo: '/login', pathMatch: 'full' },

    {
        path: 'login',
        loadComponent: () =>
            import('./Pages/login/login.component').then(
                (c) => c.LoginComponent
            ),
        title: 'Login',
    },
    {
        path: 'dashboard',

        loadComponent: () =>
            import('./Pages/dashboard/dashboard.component').then(
                (c) => c.DashboardComponent
            ),
        canActivate: [authGuard] //UNlock before merging to main
    },
    {
        path: 'create-delivery',
        loadComponent: () =>
            import('./Pages/create-delivery/create-delivery.component').then(
                (c) => c.CreateDeliveryComponent
            ),
        canActivate: [authGuard] //UNlock before merging to main
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload'
        })
    ]
})
export class AppRoutingModule {}
